module.exports = __webpack_public_path__ + "img/logo_open.d5d6101c.svg";